import JSONSchemaForm from '@rjsf/bootstrap-4';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { match } from 'react-router-dom';
import { types as coreTypes } from '@sitebuilder/core';
import { hooks as commonHooks } from '@sitebuilder/common';
import Fields from '../../components/CustomSchemaFields';
import Widgets from '../../components/CustomSchemaWidgets';
import AdminMainPanel from '../Layouts/AdminMainPanel';
import NavBar from '../Layouts/NavBar';
import { StateShape as ReduxStateShape } from '../../reducers';
import { actionCreators as contentListActionCreators } from '../../reducers/contentList';
import ContentListEditorSchema from './ContentListEditorSchema';
import '../../scss/index.scss';
// import '../../scss/user/index.scss';

interface ContentListEditorProps {
    contentListId: string;
    match: match<{
        contentListId: string;
    }>;
}

const ContentListEditor = (props: ContentListEditorProps) => {
    const dispatch = useDispatch();
    const { match } = props;
    const { contentListId } = match.params;
    const i18n = commonHooks.useLocalization();
    const [formData, setFormData] = useState<any>();
    const formRef = useRef<any>(null);

    const { contentList, contentListSaveLoading, contentListSaveSucess } = useSelector(
        (state: ReduxStateShape) => ({
            ...state.contentList,
        })
    );

    useEffect(() => {
        if (contentListId) {
            dispatch(contentListActionCreators.loadContentList(contentListId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentListId]);

    useEffect(() => {
        if (contentListId && !contentListSaveLoading && contentListSaveSucess) {
            dispatch(contentListActionCreators.loadContentList(contentListId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentListSaveSucess, contentListSaveLoading]);

    const [newContentList, setNewContentList] = useState<coreTypes.ContentList | null>(contentList);

    useEffect(() => {
        if (contentList) {
            setFormData(contentList);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentList]);

    const onClickSave = () => {
        if (newContentList) {
            dispatch(contentListActionCreators.saveNewContentList(contentListId, newContentList));
        }
    };

    const onClickSubmit = (formData: any) => {
        // Merge contentList.contentList with formData
        const updatedContentList: any = {
            ...contentList,
            contentList: {
                ...contentList?.contentList,
                ...formData,
            },
        };
        setNewContentList(updatedContentList);
    };

    return (
        <AdminMainPanel>
            <NavBar hideRightSidebar={true} />
            <div className="admin-main-content">
                <div className={`title-and-buttons-container`}>
                    <h3 className="title">{i18n.t('contentList_title')}</h3>
                    <div className="actions-container">
                        <div className="action-buttons-container">
                            <div className="button-container">
                                <button
                                    className="primary-button save-button btn btn-secondary"
                                    onClick={onClickSave}
                                >
                                    {i18n.t('save')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="editor">
                    <JSONSchemaForm
                        ref={formRef}
                        schema={ContentListEditorSchema.schema}
                        uiSchema={ContentListEditorSchema.uiSchema}
                        formData={formData}
                        widgets={Widgets}
                        fields={Fields}
                        onChange={({ formData }: any) => {
                            setFormData(formData);
                            setTimeout(() => onClickSubmit(formRef?.current?.state?.formData), 300);
                        }}
                        onError={(e: any) => console.log(e)}
                        id="Schemaform"
                    >
                        <></>
                    </JSONSchemaForm>
                </div>
            </div>
        </AdminMainPanel>
    );
};

export default ContentListEditor;
